import {createBrowserHistory} from 'history'

const initHistory = (url = '/') => {
  return createBrowserHistory()
}

export default initHistory



// WEBPACK FOOTER //
// ./src/history.js